/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Common filter properties for tours across carrier and consignee roles
 */
export enum ConsigneeToursFilterProperties {
  Status = 'status',
  TourNumber = 'tourNumber',
  ExternalTourName = 'externalTourName',
  CarrierKey = 'carrierKey',
  CarrierName = 'carrierName',
  DateClosed = 'dateClosed',
  DateCreated = 'dateCreated',
  CheckoutDate = 'checkoutDate'
}
